import { render, staticRenderFns } from "./WinnerBadgeComponent.vue?vue&type=template&id=bee1aee6&"
import script from "./WinnerBadgeComponent.vue?vue&type=script&lang=js&"
export * from "./WinnerBadgeComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports